import { RecipeVariationStep, StepSubstepUpdateMutation } from "../../app/recipeCreation/createRecipe.types";
import { SubStepTypeEnum } from "../../components/recipeCreation/utils/constants";

export const chooseDeleteType = ({
  isDeleteStep,
  substepType,
  isPreset
}: {
  isDeleteStep: boolean,
  substepType: string,
  isPreset: boolean
}) => {
  if (isDeleteStep) {
    if (isPreset && substepType === SubStepTypeEnum.INSTRUCTION) return "deletePresetStep";
    if (substepType === SubStepTypeEnum.INSTRUCTION) return "deleteInstructionStep";
    if (substepType === SubStepTypeEnum.INGREDIENTS) return "deleteIngredientStep";
    if (substepType === SubStepTypeEnum.OUTSIDE_INSTRUCTION) return "deleteOutsideInstructionStep";
  }

  if (isPreset && substepType === SubStepTypeEnum.INSTRUCTION) return "deletePreset";
  if (substepType === SubStepTypeEnum.INSTRUCTION) return "deleteInstruction";
  if (substepType === SubStepTypeEnum.INGREDIENTS) return "deleteIngredient";
  if (substepType === SubStepTypeEnum.OUTSIDE_INSTRUCTION) return "deleteOutsideInstruction";

  return null;
}

export const getUpdatedRecipeVarSteps = (
  recipeVariationSteps: RecipeVariationStep[],
  deleteStepAt: number
) => {
  const recipeVariationStepsAfterDeletedAt = recipeVariationSteps.slice(deleteStepAt + 1, recipeVariationSteps.length);
  return recipeVariationStepsAfterDeletedAt.map((recipeVarStep, index) => ({
    where: { id: { _eq: recipeVarStep.id } },
    _set: { step_rank: recipeVarStep.step_rank - 1 }
  }));
}

export const getUpdatedStepSubsteps = (
  recipeVarStep: RecipeVariationStep | null,
  deleteSubstepAt: number,
) => {

  const updatedStepSubsteps: StepSubstepUpdateMutation[] = [];

  if (recipeVarStep) {
    const stepSubsteps = recipeVarStep.StepsE3.Steps_Substeps ?? [];
    stepSubsteps.forEach((stepSubstep, index) => {

      const { SubstepsE3: excludedSubsteps, __typename, ...stepSubstepWithoutSubstep } = stepSubstep;

      if (index < deleteSubstepAt) {
        updatedStepSubsteps.push({
          where: { id: { _eq: stepSubstepWithoutSubstep.id } },
          _set: { ...stepSubstepWithoutSubstep, subStep_rank: index }
        })
      }

      if (index > deleteSubstepAt) {
        updatedStepSubsteps.push({
          where: { id: { _eq: stepSubstepWithoutSubstep.id } },
          _set: { ...stepSubstepWithoutSubstep, subStep_rank: index - 1 }
        })
      }

    })
  }
  return updatedStepSubsteps
}